import React, { useEffect, useState } from 'react';
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle
} from 'reactstrap';
import { AreaIcon, FilterBarZone, LabelCount, Separator } from './styled';
import { FiMessageSquare } from 'react-icons/fi';
import { IoBookmark } from 'react-icons/io5';
import { useQueueContentChatContext } from '../../../../../../hooks/useQueueContentChat';
import { TbBellUp } from 'react-icons/tb';
import { LuMoon } from 'react-icons/lu';
import { BiMessageAltX } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { TbFilterCog } from 'react-icons/tb';

const FILTER_ICONS = {
  INTERACTION_AGENT_CRITICAL: {
    icon: TbBellUp,
    color: '#ef4444',
    title: 'Em atraso critico do atendente'
  },
  INTERACTION_AGENT_WARNING: {
    icon: TbBellUp,
    color: '#f59e0b',
    title: 'Em atraso moderado do atendente'
  },
  CHATS_WITH_RESPONSE_AGENT: {
    icon: FiMessageSquare,
    color: '#22c55e',
    title: 'Em andamento com resposta do atendente'
  },
  INTERACTION_CLIENT: {
    icon: LuMoon,
    color: '#3b82f6',
    title: 'Inativas sem interação do cliente'
  },
  CHATS_SAVED: {
    icon: IoBookmark,
    color: '#22c55e',
    title: 'Sinalizadas'
  },
  DAILY_CLOSED: {
    icon: BiMessageAltX,
    color: '#71717a',
    title: 'Encerradas hoje'
  }
};

export const FilterBar = ({ handlerFilter }) => {
  const { primary_color } = useSelector((state) => state.systemConfiguration);

  const { chatsSaved, filters, countersChatMetrics } =
    useQueueContentChatContext();

  const [showFilters, setShowFilters] = useState(() => {
    const saved = localStorage.getItem('showFilters');
    return saved
      ? JSON.parse(saved)
      : [
          'INTERACTION_CLIENT',
          'CHATS_SAVED',
          'DAILY_CLOSED',
          'CHATS_WITH_RESPONSE_AGENT',
          'INTERACTION_AGENT_WARNING',
          'INTERACTION_AGENT_CRITICAL'
        ];
  });

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dailyClosedConversation = useSelector(
    (state) => state.updateChatMetrics.getDailyClosedChat
  );

  const sizeIcon = 26;

  useEffect(() => {
    localStorage.setItem('showFilters', JSON.stringify(showFilters));
  }, [showFilters]);

  const toggleFilter = (filterId) => {
    if (filterId === 'ALL') {
      const allFilters = Object.keys(FILTER_ICONS);
      setShowFilters(allFilters);

      return;
    }

    setShowFilters((prev) => {
      if (prev.includes(filterId)) {
        return prev.filter((id) => id !== filterId);
      }
      return [...prev, filterId];
    });
  };

  const getFilterCount = (filterId) => {
    switch (filterId) {
      case 'INTERACTION_AGENT_CRITICAL':
        return countersChatMetrics.agentCritical || 0;
      case 'INTERACTION_AGENT_WARNING':
        return countersChatMetrics.agentWarning || 0;
      case 'CHATS_WITH_RESPONSE_AGENT':
        return countersChatMetrics.withAgentResponse || 0;
      case 'INTERACTION_CLIENT':
        return countersChatMetrics.customerCritical || 0;
      case 'CHATS_SAVED':
        return chatsSaved?.size || 0;
      case 'DAILY_CLOSED':
        return dailyClosedConversation ?? 0;
      default:
        return 0;
    }
  };

  const visibleFilters = Object.keys(FILTER_ICONS).filter((filterId) =>
    showFilters.includes(filterId)
  );

  return (
    <FilterBarZone>
      {visibleFilters.map((filterId) => {
        const IconComponent = FILTER_ICONS[filterId].icon;
        return (
          <React.Fragment key={filterId}>
            <AreaIcon
              title={FILTER_ICONS[filterId].title}
              onClick={() => handlerFilter('', filterId)}
              checked={filters[filterId]}
              isFix={filterId === 'DAILY_CLOSED'}
            >
              <IconComponent
                size={sizeIcon}
                strokeWidth={filterId === 'DAILY_CLOSED' ? '0.4' : '1.8'}
                color={FILTER_ICONS[filterId].color}
              />
              <LabelCount title={`${getFilterCount(filterId)}`}>
                {getFilterCount(filterId)}
              </LabelCount>
            </AreaIcon>
            <Separator />
          </React.Fragment>
        );
      })}
      <Dropdown
        direction="right"
        onClick={() => {
          setDropdownOpen(!dropdownOpen);
        }}
        isOpen={dropdownOpen}
        toggle={() => setDropdownOpen(!dropdownOpen)}
      >
        <DropdownToggle
          outline={true}
          style={{
            background: 'none',
            border: 'none',
            margin: 0,
            padding: 0,
            marginRight: '3px',
            width: '2.5rem',
            height: '2.27rem'
          }}
        >
          <AreaIcon>
            <TbFilterCog
              style={{
                marginBottom: '1px'
              }}
              size={26}
              color={primary_color}
            />
          </AreaIcon>
        </DropdownToggle>

        <DropdownMenu>
          <DropdownItem header>Sinalizadores</DropdownItem>
          <DropdownItem divider />
          {Object.entries(FILTER_ICONS).map(
            ([filterId, { icon: IconComponent, color, title }]) => (
              <DropdownItem
                key={filterId}
                toggle={() => setDropdownOpen(!dropdownOpen)}
                onClick={(e) => {
                  toggleFilter(filterId);
                  e.stopPropagation();
                }}
              >
                <input
                  type="checkbox"
                  checked={showFilters.includes(filterId)}
                  onClick={(e) => {
                    toggleFilter(filterId);
                    e.stopPropagation();
                  }}
                  value={filterId}
                  style={{ marginRight: '5px' }}
                />
                <IconComponent
                  size={20}
                  style={{ marginRight: '5px' }}
                  color={color}
                />
                <span>{title}</span>
              </DropdownItem>
            )
          )}
        </DropdownMenu>
      </Dropdown>
    </FilterBarZone>
  );
};
